import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ErrorMessageService {
    //TODO: Use i18n framework
    get(s: string): string {
        debugger;
        switch(s) {
            case "astre1_et_astre2_parreil": return "Le premier et second astre sont les mêmes.";
            case "astre2_definit_mais_pas_humain": return "Seulement les humains peuvent avoir 2 astres.";
            case "astre2_pas_choisit": return "Vous n'avez pas choisit un second astre.";
            case "astre_invalide_pour_epouvantail": return "Les épouvantails ne peuvent pas avoir cet astre.";
            case "competence_deja_prit": return "Vous avez déjà cette compétence.";
            case "competence_est_prerequis": return "Vous n'avez pas la compétence pré-requise.";
            case "competence_indisponible": return "Cette compétence ne peut pas être achetée.";
            case "competence_locked_in": return "Cette compétence est permanente pour votre personnage.";
            case "competence_ne_peut_pas_etre_retiree": return "Vous ne pouvez pas retirer cette compétence.";
            case "competence_niveau_max": return "Cette compétence est au niveau maximum.";
            case "competence_niveau_min": return "Cette compétence est au niveau minimum.";
            case "competence_not_found": return "Cette compétence n'existe pas.";
            case "competence_pas_dans_liste": return "Cette compétence n'est pas listée.";
            case "competence_pas_niveau_1": return "Cette compétence n'est pas au niveau 1.";
            case "competence_prerequis_pas_trouve": return "Vous n'avez pas le prérequis de cette compétence.";
            case "impossible_rembourser_achat_sort_provenant_de_competence": return "Vous ne pouvez pas rembourser les points d'essences provenant d'un achat de compétence.";
            case "pas_assez_achat_disponible": return "Vous n'avez pas assez de case de compétences disponibles.";
            case "pas_assez_achat_sort_disponible": return "Vous n'avez pas assez de point d'essence.";
            case "pas_assez_crimson_disponible": return "Vous n'avez pas assez de crimson.";
            case "personnage_not_found": return "Le personnage n'a pas été trouvé.";
            case "pyramide_sort_pas_respectee": return "La pyramide de sort n'est pas respectée.";
            case "sort_de_la_competence_sur_personnage": return "Vous n'avez pas accès à ce type de sort.";
            case "sort_deja_prit": return "Vous avez déjà ce sort";
            case "sort_est_prerequis": return "Ce sort est prérequis à un autre.";
            case "sort_indisponible": return "Ce sort n'est pas disponible.";
            case "sort_locked_in": return "Ce sort est permanent pour votre personnage.";
            case "sort_not_found": return "Ce sort n'a pas été trouvé.";
            case "sort_pas_dans_liste": return "Ce sort n'est pas dans la liste.";
            case "sort_prerequis_pas_trouve": return "Les prérequis de ce sont ne sont pas remplis."
            default: return s;
        }
    }
}